(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["db-white-nav"] && !Shopify.designMode) return;
  try {
    (function () {
  function lock(on) {
    document.body.classList.toggle('db-wnav-lock', on);
  }
  function closeDrawer(host) {
    if (!host) return;
    var drawer = host.querySelector('.db-wnav-drawer');
    var mask = host.querySelector('.db-wnav-drawer__mask');
    var btn = host.querySelector('[data-db-wnav-open]');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.hidden = true;
    }
    if (mask) mask.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
    lock(false);
  }
  function openDrawer(host) {
    var drawer = host.querySelector('.db-wnav-drawer');
    var mask = host.querySelector('.db-wnav-drawer__mask');
    var btn = host.querySelector('[data-db-wnav-open]');
    if (drawer) {
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
    }
    if (mask) mask.hidden = false;
    if (btn) btn.setAttribute('aria-expanded', 'true');
    lock(true);
  }
  function bindLocFlags() {
    if (document.documentElement.dataset.dbLocBound === '1') return;
    document.documentElement.dataset.dbLocBound = '1';
    document.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-db-loc-opt]');
      if (!opt) return;
      var form = opt.closest('form');
      if (!form) return;
      e.preventDefault();
      var lang = form.querySelector('input[name="language_code"]');
      var country = form.querySelector('input[name="country_code"]');
      if (lang) lang.value = opt.getAttribute('data-lang') || lang.value;
      if (country && opt.getAttribute('data-country')) country.value = opt.getAttribute('data-country');
      form.submit();
    });
  }
  function bindDesktopNav() {
    document.querySelectorAll('[data-db-nav]').forEach(function (nav) {
      if (nav.dataset.dbNavBound === '1') return;
      nav.dataset.dbNavBound = '1';

      var items = Array.prototype.slice.call(nav.querySelectorAll('[data-db-nav-item]'));
      var closeTimer;

      function setOpen(item, open) {
        var trigger = item.querySelector('[data-db-nav-trigger]');
        var panel = item.querySelector('[data-db-nav-panel]');
        if (open) item.setAttribute('data-open', '');
        else item.removeAttribute('data-open');
        if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.hidden = !open;
      }

      function closeAll(except) {
        items.forEach(function (item) {
          if (item !== except) setOpen(item, false);
        });
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-db-nav-trigger]');

        item.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'touch') return;
          window.clearTimeout(closeTimer);
          closeAll(item);
          setOpen(item, true);
        });

        item.addEventListener('pointerleave', function (e) {
          if (e.pointerType === 'touch') return;
          closeTimer = window.setTimeout(function () {
            setOpen(item, false);
          }, 160);
        });

        // Touch and keyboard: the first activation opens the panel instead of
        // navigating, so a parent category's children are reachable by tap.
        if (trigger) {
          trigger.addEventListener('click', function (e) {
            var isOpen = item.hasAttribute('data-open');
            if (!isOpen) {
              e.preventDefault();
              closeAll(item);
              setOpen(item, true);
            }
          });
        }

        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) setOpen(item, false);
        });
      });

      nav.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          var open = nav.querySelector('[data-db-nav-item][data-open]');
          if (!open) return;
          setOpen(open, false);
          var trigger = open.querySelector('[data-db-nav-trigger]');
          if (trigger) trigger.focus();
        }
      });

      document.addEventListener('click', function (e) {
        if (!nav.contains(e.target)) closeAll(null);
      });
    });
  }
  function bind() {
    bindLocFlags();
    bindDesktopNav();
    document.querySelectorAll('.db-wnav-drawer-host').forEach(function (host) {
      if (host.dataset.dbBound === '1') return;
      host.dataset.dbBound = '1';
      host.addEventListener('click', function (e) {
        if (e.target.closest('[data-db-wnav-open]')) {
          e.preventDefault();
          var drawer = host.querySelector('.db-wnav-drawer');
          if (drawer && !drawer.hidden) closeDrawer(host);
          else openDrawer(host);
        } else if (e.target.closest('[data-db-wnav-close]')) {
          e.preventDefault();
          closeDrawer(host);
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.db-wnav-drawer-host').forEach(closeDrawer);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();
  } catch(e) { console.error(e); }
})();

})();
